<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Quality Control Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Update Quality Control">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit quality control'">
      <template #gated-content>
        <quality-control-add-form @submit="submit" :qualityControl="qualityControl"></quality-control-add-form>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import QualityControlAddForm from "@/components/lab/qualitycontrol/QualityControlAddForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { qualityControlNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

const QualityControlRepository = LabRepositoryFactory.get("qualityControl");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    QualityControlAddForm,
  },
  data() {
    return {
      loading: true,
      quality_control_id: this.$route.params.quality_control_id || null,
      qualityControl: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/quality-control",
            title: "Quality Control list",
          },
          {
            icon: "fa-eye",
            linkto: `/quality-control/${this.quality_control_id}`,
            title: "View Quality Control",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      console.log(form_data)
      try {
        await QualityControlRepository.update(this.quality_control_id, form_data);

        this.editSuccess();
        this.$router.push(`/quality-control/${this.quality_control_id}`);
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.qualityControl = await getModel({
      model_type: "quality_control",
      id: this.quality_control_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: qualityControlNotifications,
};
</script>
